/**
 * TPM PUBLIC API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BrandColours } from './brandColours';
import { FontEnum } from './fontEnum';


/**
 * The practice\'s look. Empty values (no logo, no colours, no links) keep Beavivo\'s.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface Brand { 
    practiceName: string;
    logoUrl: string | null;
    websiteUrl: string;
    supportUrl: string;
    colours: BrandColours | null;
    font: FontEnum | null;
}
export namespace Brand {
}

export const Brand_practiceName_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const Brand_logoUrl_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const Brand_websiteUrl_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const Brand_supportUrl_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const Brand_colours_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const Brand_font_Validators: ValidatorFn[] =
    [  Validators.required, ];


